/**
 * Simple selector to bucketRoll
 * @param state
 * @returns {bucketRoll|null}
 */
export const getBucketRoll = (state) => state.bucketRoll.bucketRoll || {};
